import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { DELIVERY_BLOTTER_FIELDS, SEARCH_DELIVERY_BLOTTER_FIELDS } from '../../Models/BlotterTables';


export const DeliveryBlotter = () => {

    const config = SEARCH_DELIVERY_BLOTTER_FIELDS

    const getDeliveryBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return DELIVERY_BLOTTER_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "shipmentDate":
                    minWidth = 150
                    break;
                case "physicalOrderNo":
                    minWidth = 160
                    break;
                case "exciseInvoiceNo":
                    minWidth = 150
                    break;
                case "partnerOrderId":
                    minWidth = 150
                    break;
                case "synchronizedAt":
                    minWidth = 150
                    break;
                case "deliveryPartnerUpdateDate":
                    minWidth = 190
                    break;
                case "trackStatusDescription":
                    minWidth = 170
                    break;
                case "trackStatusCode":
                    minWidth = 150
                    break;
                case "trackingDetails":
                    minWidth = 160
                    break;

                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const DeliveryBlotterRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
    }
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Delivery Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getDeliveryBlotterColumns()} rows={DeliveryBlotterRows} />
        </div>
    )
}
